import React, { Fragment } from "react";
// import { Parser } from "json2csv";
import { TextButton } from "../../../element-components";
import { normalizeString } from "../../../util/functions";
import { getNestedData } from "../../../util/accessors";
import { formatDate, getCurrency } from "../../../util/formating";

// const parser = new Parser();

const _createField = ({ Header, type, id }) => {
  return {
    label: Header,
    value: (row) => {
      let value = getNestedData({ object: row, path: id });

      if (type === "boolean") value = Boolean(value) ? "Yes" : "No";
      else if (type === "percent") value = value * 100;
      else if (type === "amount") value = getCurrency({ amount: value, actions: ["divide"] });
      else if (type === "date") {
        value = formatDate({
          data: value,
          actions: ["excel"],
          options: ["append-timezone"],
        });
      } else if (type === "ts") {
        value = formatDate({
          data: value,
          actions: ["excel"],
        });
      }

      return value;
    },
    default: "",
  };
};

const _accumulateParents = ({ header, label }) => {
  const parent = label;

  if (header.parent) {
    label = `${header.parent.id} ${label}`;
    return _accumulateParents({ header: header.parent, label });
  }

  return parent;
};

const TableDownload = (props) => {
  const { config, rows, headerGroups } = props;

  const handleDownload = () => {
    const fields = headerGroups[headerGroups.length - 1]?.headers.reduce((acc, header) => {
      const { disableRender, Header, type, id, downloadOverride } = header;

      if (!disableRender && !id?.includes("filter") && type !== "button" && Header !== "Copy ID" && Header !== "Copy Row Data") {
        if (downloadOverride?.length >= 0) {
          for (const { Header, type, id } of downloadOverride) acc.push(_createField({ Header, type, id }));
        } else {
          const label = _accumulateParents({ header, label: Header });
          acc.push(_createField({ Header: label, id, type }));
        }
      }

      return acc;
    }, []);

    // const csv = parser.parse(
    //   rows.reduce((acc, { original }) => {
    //     const { subRows } = original;
    //     acc.push(original);

    //     if (subRows && subRows[0]?.children) acc = acc.concat(subRows[0]?.children);
    //     return acc;
    //   }, []),
    //   { fields }
    // );
    const csv = null;

    const element = document.createElement("a");
    element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(csv));
    element.setAttribute("download", `${config.nameSpace}.csv`);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  if (!config.disableDownload) {
    return <TextButton
      onClick={() => handleDownload()}
      text={normalizeString({ data: "Export to CSV", actions: ["nobreak"] })}
      margin="0 10px 0 0"
      innerMargin="0"
      style={{ alignSelf: "center" }}
      variant="t6"
      color="tertiary"
    ></TextButton>
  } else return <Fragment />
};

export default TableDownload;
